import { render, staticRenderFns } from "./brands.pug?vue&type=template&id=1b56ff29&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./brands.scss?vue&type=style&index=0&id=1b56ff29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56ff29",
  null
  
)

export default component.exports